function determineHidden() {
  let hidden = 'hidden'
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden'
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
  }

  return hidden
}

function determineVisibilityChange() {
  let visibilityChange = 'visibilitychange'
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    visibilityChange = 'visibilitychange'
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange'
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange'
  }

  return visibilityChange
}

export const hidden = determineHidden()
export const visibilityChange = determineVisibilityChange()

export const availableCountries = ['AT', 'CH', 'DE', 'HU', 'UK', 'US']
export const currencies = [
  'EUR',
  'GBP',
  'USD',
  'HUF',
  'CHF',
  'DKK',
  'SEK',
  'AUD',
  'CZK',
  'NOK',
  'PLN',
  'RON'
]
export const currencySymbol = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  HUF: 'Ft',
  CHF: 'CHF',
  DKK: 'kr',
  SEK: 'kr',
  AUD: '$',
  CZK: 'Kč',
  NOK: 'kr',
  PLN: 'zł',
  RON: 'lei'
}
export const currencyPrecisions = {
  EUR: { precision: 2 },
  GBP: { precision: 2 },
  USD: { precision: 2 },
  HUF: { precision: 0 },
  CHF: { precision: 2 },
  DKK: { precision: 2 },
  SEK: { precision: 2 },
  AUD: { precision: 2 },
  CZK: { precision: 2 },
  NOK: { precision: 2 },
  PLN: { precision: 2 },
  RON: { precision: 2 }
}

export const taxClasses = {
  NORMAL: 'normal',
  REDUCED: 'reduced',
  SUPER_REDUCED: 'super_reduced'
}

/**
 * @name License options
 * @description map of avaliable license options. Example: license.GASTRO -> gastropos-mobile
 */
export const license = {
  GASTRO: 'gastropos-mobile', // Gastro License - iOS POS with tables
  FULL_MOBILE: 'fullpos-mobile', // Retail License
  FULL_STATIONATY: 'fullpos-stationary', // Tillhub Multi License
  LITEPOS: 'litepos-mobile', // POS Go License
  EDA: 'eda' // Warehub License
}

/**
 * @name Language ISO
 * @description map of avaliable language names with ISO code values. Example: languageISO.GERMAN -> de-DE
 */
export const languageISO = {
  GERMAN: 'de-DE',
  ENGLISH: 'en-US',
  CZECH: 'cs-CZ',
  FRENCH: 'fr-FR',
  ITALIAN: 'it-IT'
}

/**
 * @name Gastro locale suffix
 * @description string suffix for locale when license includes 'gastropos-mobile'. Example: de-DE => de-DE-gastro
 */
export const gastroLocaleSuffix = '-gastro'

export const HEADERS_MAP = (vm) => ({
  quantity: {
    default: vm.$t('pages.document_designer.headers.quantity'),
    custom: null,
    show: true,
    section: 'items'
  },
  product_name: {
    default: vm.$t('pages.document_designer.headers.productName'),
    custom: null,
    show: true,
    section: 'items'
  },
  attributes: {
    default: vm.$t('pages.document_designer.headers.attributes'),
    custom: null,
    show: true,
    section: 'items'
  },
  comments: {
    default: vm.$t('pages.document_designer.headers.comments'),
    custom: null,
    show: false,
    section: 'items'
  },
  unit_price_exclude_vat: {
    default: vm.$t('pages.document_designer.headers.unitPriceExcludeVat'),
    custom: null,
    show: true,
    section: 'items'
  },
  unit_price_include_vat: {
    default: vm.$t('pages.document_designer.headers.unitPriceIncludeVat'),
    custom: null,
    show: true,
    section: 'items'
  },
  discount: {
    default: vm.$t('pages.document_designer.headers.discount'),
    custom: null,
    show: true,
    section: 'items'
  },
  total_price_include_vat: {
    default: vm.$t('pages.document_designer.headers.totalPriceIncludeVat'),
    custom: null,
    show: true,
    section: 'items'
  },
  vat_percentage: {
    default: vm.$t('pages.document_designer.headers.vatPercentage'),
    custom: null,
    show: true,
    section: 'items'
  },
  net_total: {
    default: vm.$t('pages.document_designer.headers.netTotal'),
    custom: null,
    show: true,
    section: 'summary'
  },
  total: {
    default: vm.$t('pages.document_designer.headers.total'),
    custom: null,
    show: true,
    section: 'summary'
  },
  total_discount: {
    default: vm.$t('pages.document_designer.headers.totalDiscount'),
    custom: null,
    show: true,
    section: 'summary'
  },
  VAT: {
    default: vm.$t('pages.document_designer.headers.VAT'),
    custom: null,
    show: true,
    section: 'summary'
  },
  product_number: {
    default: vm.$t('pages.document_designer.headers.product_number'),
    custom: null,
    show: true,
    section: 'items'
  }
})

export const NOTIFICATIONS_TYPES = {
  LOADING: 'loading',
  PROGRESS: 'progress',
  SUCCESS: 'success',
  ERROR: 'error',
  EXPIRED: 'expired',
  EMPTY: 'empty',
  INFO: 'info',
  TIMEOUT: 'timeout'
}

export const whitelabels = {
  LOCALSEARCH: 'localsearch'
}

export const localsearchLinks = {
  help_center: 'https://www.mycash-help.localsearch.ch',
  help_center_search: 'https://mycash-help.localsearch.ch/api.php/search?q',
  contact: 'https://www.localsearch.ch/de/mycash'
}

export const tillhubLinks = {
  help_center_base: 'https://help.unzer.com',
  help_center_search: '#',
  contact: 'https://www.tillhub.de/kontakt/'
}

export function getTillhubHelpCenterLink(locale) {
  const language =
    typeof locale === 'string' && locale.toLowerCase().startsWith('en')
      ? 'en'
      : 'de'
  return `${tillhubLinks.help_center_base}/${language}/support/home`
}

const UNZER_ONE_DASHBOARD_HELP_FOLDER_ID = '79000089253'

// UnzerOne Dashboard folder of the Unzer help center, available in German and English only (French falls back to English)
export function getUnzerSupportDocsLink(locale) {
  const language =
    typeof locale === 'string' && locale.toLowerCase().startsWith('de')
      ? 'de'
      : 'en'
  return `${tillhubLinks.help_center_base}/${language}/support/solutions/folders/${UNZER_ONE_DASHBOARD_HELP_FOLDER_ID}`
}

export const popoverPlacements = [
  'top',
  'top-start',
  'top-end',
  'bottom',
  'bottom-start',
  'bottom-end',
  'left',
  'left-start',
  'left-end',
  'right',
  'right-start',
  'right-end'
]

export const ADDRESS_FIELDS = {
  STREET: 'street',
  STREET_NUMBER: 'street_number',
  LOCALITY: 'locality',
  POSTAL_CODE: 'postal_code',
  REGION: 'region',
  COUNTRY: 'country'
}

export const STAFF_PHONE_TYPES = {
  ANY: 'any',
  HOME: 'home',
  WORK: 'work',
  MOBILE: 'mobile'
}

export const CUSTOMERS_PHONE_TYPES = {
  MAIN: 'main',
  HOME: 'home',
  WORK: 'work',
  MOBILE: 'mobile'
}

export const SUPPLIERS_PHONE_TYPES = {
  MAIN: 'main',
  HOME: 'home',
  WORK: 'work',
  MOBILE: 'mobile'
}

/** UNIFIED COMMERCE WHITELABEL START */
import { env } from '@shared/config/env'

export const isUnifiedCommerce = () => {
  const isUnzerURL = window.location.hostname.includes('unzer.')
  return env.isUnifiedCommerce || isUnzerURL
}

export const isKeycloackEnabled = () => {
  return env.keycloakEnabled === 'true'
}

/**
 * True when sessions are Keycloak sessions: Unified Commerce with Keycloak enabled. Every other
 * combination logs in through the Tillhub API, including the support login, and its sessions are
 * revoked through the Tillhub API on logout.
 */
export const usesKeycloakLogin = () =>
  isUnifiedCommerce() && isKeycloackEnabled()

export const unifiedCommerceExcludedScopes = [
  'settings:account',
  'resources:branches:create',
  'resources:branches:update',
  'resources:branches:delete',
  'resources:registers:create',
  'resources:registers:update'
]

export const setUnifiedCommerceWindow = (isUnifiedCommerce) => {
  Object.defineProperty(window, 'location', {
    value: {
      hostname: isUnifiedCommerce ? 'dashboard.unzer.com' : 'localhost'
    },
    writable: true
  })
}

/** UNIFIED COMMERCE WHITELABEL END */

// We support DE, EN & FR for Unzer one dashboard UOD
export const locales = [
  {
    value: 'de-DE',
    label: 'Deutsch (de-DE)'
  },
  {
    value: 'en-US',
    label: 'English (en-US)'
  },
  {
    value: 'fr-FR',
    label: 'Français (fr-FR)'
  }
].concat(
  !isUnifiedCommerce()
    ? [
        {
          value: 'cs-CZ',
          label: 'Čeština (cs-CZ)'
        },
        {
          value: 'it-IT',
          label: 'Italiano (it-IT)'
        }
      ]
    : []
)

export const fonts = [
  {
    value: 'system_font',
    label: 'System Font'
  },
  {
    value: 'arial',
    label: 'Arial'
  }
]

export const forms = [
  {
    value: 'rounded',
    label: 'Rounded'
  },
  {
    value: 'squared',
    label: 'Squared'
  }
]
